import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/homepage';
export function FaqPreview() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <section id="faq" aria-labelledby="faq-heading" className="bg-navy py-24 text-paper md:py-32" data-id="element-5" data-mp="1orukrj8arzrt">
      <div className="mx-auto max-w-4xl px-6 md:px-10" data-id="element-6" data-mp="1js9oxhofc7jb">
        <Reveal data-id="element-7" data-mp="1eywzj5bx7wpi">
          <h2 id="faq-heading" className="font-serif text-4xl font-semibold leading-tight md:text-5xl" data-id="element-8" data-mp="1eydrqhfziop7">
            Common questions
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-9" data-mp="15zk0l6lfaqj1" />
        </Reveal>

        <Reveal className="mt-12 border-t border-paper/15" data-id="element-10" data-mp="10znvf40zot1w">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <div key={faq.question} className="border-b border-paper/15" data-id="element-11" data-mp="3lws3dzzf5mf8" data-mpi={i}>
                <h3 data-id="element-12" data-mp="3qq3b03c22787">
                  <button id={buttonId} type="button" aria-expanded={open} aria-controls={panelId} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left text-xl font-medium transition-colors duration-150 ease-out hover:text-gold md:text-2xl" data-id="element-13" data-mp="3qqmggkkir35c">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`h-6 w-6 shrink-0 text-gold transition-transform duration-200 ease-out ${open ? 'rotate-45' : ''}`} data-id="element-14" data-mp="3vn399s2ny5or" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-15" data-mp="2p8lrcs063rqx">
                  {open && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-16" data-mp="255y7shhetp32">
                      <p className="max-w-3xl pb-8 text-lg leading-relaxed text-paper/85" data-id="element-17" data-mp="1hg3y28se0gn1">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </Reveal>

        <a href="/faq" className="mt-10 inline-flex items-center gap-2 text-lg font-semibold text-gold underline-offset-[6px] hover:underline" data-id="element-18" data-mp="18hryvidggaiz">
          See all FAQs
          <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-19" data-mp="32uhvi7v7jxu2" />
        </a>
      </div>
    </section>;
}